import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Urls } from 'src/app/Helpers/Urls';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  url = new Urls();
  apiUrl: string;
  orgId: number;

  constructor(
    private httpclient: HttpClient
  ) {
      this.apiUrl = environment.flmApiUrl;
  }

  getFiles(page, size, fileid, filename, bucketname, start, end) {
    // tslint:disable-next-line: max-line-length
    const url = this.apiUrl + '/api/files/' + page + '/' + size + '/' + fileid + '/' + filename
     + '/' + bucketname + '/' + start + '/' + end + '/';
    return this.httpclient.get<any>(url)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  getFile(bucketname, filename) {
    // tslint:disable-next-line: max-line-length
    const url = this.apiUrl + '/api/files/' + bucketname + '/' + filename + '/';
    return this.httpclient.get<any>(url)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  downloadFile(url, type) {
    let headers = new HttpHeaders();
    // headers = headers.set('Accept', 'application/pdf');
    headers = headers.set('Accept', type);
    return this.httpclient.get(url, { headers, responseType: 'blob' });
  }

  postFile(file) {
    return this.httpclient.post(this.apiUrl + '/api/files', file)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  deleteFile(file): Observable<any> {
    const del = JSON.stringify(file);
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.httpclient.delete<any>(this.apiUrl + '/api/files/' + del, options)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  private handleError(error: any) {
    throw error;
    return error;
  }

}
